module.exports = __webpack_public_path__ + "static/media/team1.0713ea03.svg";